import { useAuth } from "../auth";
import { COMPANIES } from "../api";

export const myCompaniesOf = (user) =>
  (user?.companies && user.companies.length) ? user.companies : COMPANIES;

export default function CompanyScopeBar({ company, setCompany }) {
  const { user } = useAuth();
  const my = myCompaniesOf(user);
  if (my.length <= 1) return null;
  return (
    <div className="company-switch" data-testid="company-scope-bar">
      <button className={company === "" ? "selected" : ""} onClick={() => setCompany("")} data-testid="company-all-button">Tümü</button>
      {my.map((c) => (
        <button key={c} className={company === c ? "selected" : ""} onClick={() => setCompany(c)} data-testid={`company-${c === "REEN Enerji" ? "enerji" : "mt"}-button`}>{c}</button>
      ))}
    </div>
  );
}
